const Map = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5013 15.0003L1.66797 18.3337V5.00033L7.5013 1.66699M7.5013 15.0003L13.3346 18.3337M7.5013 15.0003V1.66699M13.3346 18.3337L18.3346 15.0003V1.66699L13.3346 5.00033M13.3346 18.3337V5.00033M13.3346 5.00033L7.5013 1.66699"
      stroke="#535862"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Map;
